import React from "react";
import { AlertTriangleIcon, BookOpenIcon, BrainIcon, ClockIcon, FrownIcon, HelpCircleIcon } from "lucide-react";
import { images, painPoints } from "../../data/content";
import { CtaButton } from "../CtaButton";
const icons = {
  alert: AlertTriangleIcon,
  clock: ClockIcon,
  help: HelpCircleIcon,
  books: BookOpenIcon,
  brain: BrainIcon,
  frown: FrownIcon
};
export function PainPoints() {
  return <section className="bg-cream-50 px-5 py-16 md:py-24" data-id="element-213" data-mp="2hjf91gl1p23c">
      <div className="mx-auto max-w-4xl" data-id="element-214" data-mp="2cldrj039patz">
        <h2 className="text-center font-serif text-3xl font-bold leading-tight text-navy-950 md:text-5xl" data-id="element-215" data-mp="2ckc4rycw2zwf">
          Do any of these sound familiar?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[17px] text-muted" data-id="element-216" data-mp="2mjl2n2avkyo2">
          If you answer <strong className="text-ink" data-id="element-217" data-mp="w75hg4zootz8">yes</strong> to any of these, I created this system with you in mind.
        </p>

        <ul className="mt-10 grid gap-3 md:grid-cols-2" data-id="element-218" data-mp="s61yh9mcahts">
          {painPoints.map(p => {
          const Icon = icons[p.icon];
          return <li key={p.text} className="flex gap-4 rounded-2xl bg-white p-5 ring-1 ring-cream-200" data-id="element-219" data-mp="1n5qnn198sjwv">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy-900 text-gold-400" data-id="element-220" data-mp="1s4tosam3q5zk">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-221" data-mp="21wg1kbe38d4f" />
                </span>
                <p className="text-[16px] leading-relaxed text-ink" data-id="element-222" data-mp="26vsyxq2l52l9">{p.text}</p>
              </li>;
        })}
        </ul>

        <div className="mt-16 rounded-3xl bg-navy-900 px-6 py-10 text-center text-white md:px-12" data-id="element-223" data-mp="2awcu4o3llw4r">
          <h3 className="font-serif text-2xl font-bold leading-tight md:text-4xl" data-id="element-224" data-mp="2fxiosrgtjtgx">
            And I don't believe the problem is that you need to study more.
          </h3>
          <p className="mx-auto mt-5 max-w-xl text-[17px] leading-relaxed text-navy-100" data-id="element-225" data-mp="lipuqwvl3ar3">
            The problem may be that nobody ever gave you a <strong className="text-gold-400" data-id="element-226" data-mp="qic959n5ex1h">visual system</strong> for organizing everything you already know. I didn't want to create another 15-hour course. I wanted something you could open, put in front of you, and use to structure a case in about 15 minutes.
          </p>
          <p className="mt-8 text-sm font-semibold uppercase tracking-wider text-navy-100/70" data-id="element-227" data-mp="sfav0m5vyz32">That's why I created</p>
          <p className="mt-2 font-serif text-3xl font-extrabold text-gold-400 md:text-5xl" data-id="element-228" data-mp="nf6eiw4za4cu">Rhinoplasty MasterMap™</p>
          <img src={images.mainMockup} alt="Rhinoplasty MasterMap™ complete package" className="mx-auto mt-6 w-full max-w-lg" data-id="element-229" data-mp="11dwbmbrss417" />
          <CtaButton className="mt-6" tone="dark" label="I want my MasterMap" data-id="element-230" data-mp="1b5iv0veah9f1" />
        </div>
      </div>
    </section>;
}